import { defaultShouldDehydrateQuery, QueryClient } from '@tanstack/react-query';
import { TRPCClientError } from '@trpc/client';
import { FetchError } from '@/lib/errors/fetchError';

function getHttpStatus(error: unknown): number | null {
  if (error instanceof FetchError) {
    return error.status;
  }
  if (error instanceof TRPCClientError) {
    const httpStatus = (error.data as { httpStatus?: number } | null | undefined)?.httpStatus;
    return typeof httpStatus === 'number' ? httpStatus : null;
  }
  return null;
}

const HTTP_TIMEOUT = 408;

export function isClientError(error: unknown): boolean {
  const status = getHttpStatus(error);
  return status !== null && status >= 400 && status < 500 && status !== HTTP_TIMEOUT;
}

const MAX_RETRIES = 3;

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000,
        retry: (failureCount, error) => {
          if (isClientError(error)) {
            return false;
          }
          return failureCount < MAX_RETRIES;
        },
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30_000),
      },
      dehydrate: {
        shouldDehydrateQuery: (query) => defaultShouldDehydrateQuery(query) || query.state.status === 'pending',
      },
      hydrate: {},
    },
  });
}
